import React from "react";

const InputPasswordValidation = React.createClass( {
    propTypes: {
        onParentChange: React.PropTypes.func
    },

    getDefaultProps: function () {
        return {
            allowAphabeticalChars: true,
            allowNumericChars: true,
            allowSpecialChars: true,
            allowCaseSensitiveChars: true,
            allowConsecutiveNumericChars: true,
            allowRepeatPosition: true,
            allowIdenticalChars: true,
            minCharsAllowed: 8,
            maxCharsAllowed: 32
        };
    },

    getInitialState: function () {
        return {
            value: this.props.clave,
            oneAphabeticalChar: false,
            oneNumericChar: false,
            oneSpecialChar: false,
            minChars: false,
            lowerUpperChar: false,
            consecutiveNumbers: true,
            identicalChars: true,
            showPopup: false,
            repeatPosition: false
        };
    },

    onInputPassChange: function ( event ) {
        this.doValidations( event, event.target.value, true );
    },

    doValidations( event, newValue, raiseParentEvent ) {
        let status = true;
        let msgError = undefined;
        let isValid = true;
        let regExp = undefined;
        let regExpAux = undefined;

        if ( this.props.allowAphabeticalChars ) {
            regExp = /[a-z]/gi;
            status = regExp.test( newValue );
            if ( !status ) {
                isValid = false;
            }
            this.setState( { oneAphabeticalChar: status } );
        }

        if ( this.props.allowNumericChars ) {
            regExp = /[0-9]/g;
            status = regExp.test( newValue );
            if ( !status ) {
                isValid = false;
            }
            this.setState( { oneNumericChar: status } );
        }

        if ( this.props.allowSpecialChars ) {
            regExp = /[\x21-\x2F\x3A-\x40\x5B-\x60\x7B-\x7E]/g;
            status = regExp.test( newValue );
            if ( !status ) {
                isValid = false;
            }
            this.setState( { oneSpecialChar: status } );
        }

        if ( this.props.allowCaseSensitiveChars ) {
            regExp = /[a-z]/g;
            regExpAux = /[A-Z]/g;
            status = regExp.test( newValue ) && regExpAux.test( newValue );
            if ( !status ) {
                isValid = false;
            }
            this.setState( { lowerUpperChar: status } );
        }

        //Valida que la nueva clave no tenga caracteres iguales en la misma posicion con la anterior...
        if ( this.props.allowRepeatPosition ) {

            status = true;
            for ( var i = 0; i < newValue.length; i++ ) {
                if ( this.state.claveOriginal != undefined && this.state.claveOriginal.charAt( i ) != "" ) {
                    if ( this.state.claveOriginal.charAt( i ) == newValue.charAt( i ) ) {
                        status = false;
                        break;
                    }
                }
            }
            if ( !status ) {
                isValid = false;
            }
            this.setState( { repeatPosition: status } );
        }

        if ( this.props.allowConsecutiveNumericChars ) {
            //regExp = /(?:0(?=1)|1(?=2)|2(?=3)|3(?=4)|4(?=5)|5(?=6)|6(?=7)|7(?=8)|8(?=9))\d/g;
            //regExp = /(?:0(?=1)|1(?=2)|2(?=3)|3(?=4)|4(?=5)|5(?=6)|6(?=7)|7(?=8)|8(?=9)|9(?=0)){1}\d|(?:0(?=9)|1(?=0)|2(?=1)|3(?=2)|4(?=3)|5(?=4)|6(?=5)|7(?=6)|8(?=7)|9(?=8)){1}\d/g;
            regExp = /(?:0(?=0)|1(?=1)|2(?=2)|3(?=3)|4(?=4)|5(?=5)|6(?=6)|7(?=7)|8(?=8)|9(?=9))\d/g;

            status = !regExp.test( newValue );
            if ( !status ) {
                isValid = false;
            }
            this.setState( { consecutiveNumbers: status } );
        }

        if ( this.props.allowIdenticalChars ) {
            regExp = /^\w{0,}(.)\1+\w{0,}$y/g;
            status = !regExp.test( newValue );
            if ( !status ) {
                isValid = false;
            }
            this.setState( { identicalChars: status } );
        }

        status = this.props.minCharsAllowed <= newValue.length;
        if ( !status ) { isValid = false; }
        this.setState( { value: newValue, minChars: status } );

        if ( raiseParentEvent ) {
            event.statusInputPass = isValid;
            this.props.onParentChange( event );
        }
    },

    componentDidMount: function () {
        this.doValidations( undefined, this.state.value || "", false );
    },

    render: function () {
        return (
            <div className="password">
                <div className="row bottom-separator-xxs">
                    <div className="col-xs-12">
                        <input
                            className={"pull-left " + this.props.inputClass}
                            value={this.state.value}
                            maxLength={this.props.maxCharsAllowed}
                            onChange={this.onInputPassChange}
                            type={this.props.showPassword ? "input" : "password"}
                            {...this.props} />
                    </div>
                </div>

                <div className="row password-item">
                    {this.props.allowAphabeticalChars &&
                        <div className="col-xs-12 col-sm-6">
                            <label className={"dot-2 " + ( this.state.oneAphabeticalChar ? "active" : "" )} >
                                Un caracter alfabético</label>
                        </div>}

                    {this.props.allowNumericChars &&
                        <div className="col-xs-12 col-sm-6">
                            <label className={"dot-2 " + ( this.state.oneNumericChar ? "active" : "" )} >
                                Un numero</label>
                        </div>}

                    {this.props.allowSpecialChars &&
                        <div className="col-xs-12 col-sm-6">
                            <label className={"dot-2 " + ( this.state.oneSpecialChar ? "active" : "" )} >
                                Un caracter especial</label>
                        </div>}

                    {this.props.allowCaseSensitiveChars &&
                        <div className="col-xs-12 col-sm-6">
                            <label className={"dot-2 " + ( this.state.lowerUpperChar ? "active" : "" )} >
                                Una mayúscula y minúscula</label>
                        </div>}

                    <div className="col-xs-12 col-sm-6">
                        <label className={"dot-2 " + ( this.state.minChars ? "active" : "" )} >
                            {this.props.minCharsAllowed} caracteres como minimo</label>
                    </div>

                    {this.props.allowConsecutiveNumericChars &&
                        <div className="col-xs-12 col-sm-6">
                            <label className={"dot-2 " + ( this.state.consecutiveNumbers ? "active" : "" )} >
                                No repetición de números seguidos</label>
                        </div>}

                    {this.props.allowIdenticalChars &&
                        <div className="col-xs-12 col-sm-6">
                            <label className={"dot-2 " + ( this.state.identicalChars ? "active" : "" )} >
                                No repetición de caracteres seguidos</label>
                        </div>}

                    {this.props.allowRepeatPosition &&
                        <div className="col-xs-12 col-sm-6">
                            <label className={"dot-2 " + ( this.state.repeatPosition ? "active" : "" )} >
                                No permita el mismo caracter en la misma posición de la contraseña anterior</label>
                        </div>}
                </div>
            </div>
        );
    }
} );

export default InputPasswordValidation;


// WEBPACK FOOTER //
// ./Portico/App/Screens/CambioContrasena/components/InputPasswordValidation.jsx